import type { useComposerCaptureDraftRestorer } from './use-composer-capture-draft-restorer';
type Draft = ReturnType<
  ReturnType<typeof useComposerCaptureDraftRestorer>['captureComposerDraft']
>;
/** Clear local state without changing the draft saved for another scope. */
export function emptyComposerDraft(draft: Draft): Draft {
  return {
    ...draft,
    editingQueueItemId: null,
    queueEditBase: null,
    preEditDraft: null,
    serializedText: '',
    stagedCanvasPrompt: null,
    selectedMailConnectorRefs: [],
    referenceCreationIntent: null,
    referenceTokenBindings: [],
    pendingSelectedSuggestion: null,
    deepResearchEnabled: false,
    snapshot: {
      currentAttachments: [],
      currentProductUploads: [],
      currentStyleUploads: [],
      currentColorUploads: [],
      currentSelectedProductPresetIds: [],
      currentSelectedProductPresetSubtypeSelections: [],
      currentSelectedDesignPresetIds: [],
      currentSelectedPatternPresetIds: [],
      currentSelectedColorPresetIds: [],
      currentSelectedColorPalette: [],
      currentSelectedImages: [],
      currentSelectedComposerFormats: [],
      currentSelectedComposerAvatars: [],
      currentSelectedReferences: [],
      currentSelectedTrendMarkets: [],
      currentSelectedUserSkills: [],
      currentSelectedOutputIntents: [],
      currentSelectedMailConnectors: [],
      currentCanvasNodeContexts: [],
      currentCanvasAnnotations: [],
      currentSheetSelections: [],
      currentSheetAnnotationBatches: [],
      currentSheetAnnotationReferences: [],
      currentSelectedProductPresetId: null,
      currentSelectedStylePresetId: null,
      currentSelectedAestheticId: null,
      currentSelectedCustomColorPalette: null,
      currentSelectedBrandingId: null,
      currentSelectedBrandingIds: [],
      currentSelectedTrendData: null,
      currentBrandCreationIntent: null,
      currentSkillEditIntent: null,
      currentDesignIntent: null,
      currentReferenceCreationIntent: null,
      currentDeepResearchEnabled: false,
      currentSelectedFixedModelAliasForSend: null,
      currentSkillCreationIntentEnabled: false,
      currentSelectedTrendYear: 'current',
      currentSelectedSendThreadTargets: {
        existingThreadIds: [],
        newThreadCount: 0,
      },
    },
  };
}
